let [OneStepNoTimePanel, PanelEvent] = require("activity/OneStepActivity/OneStepNoTimePanel")
let TimeModeActivityNoTimePanel = xClass("TimeModeActivityNoTimePanel", OneStepNoTimePanel, () => {
    return cc.CSLoader.createNode("cocos/one_step_get_count_panel.csb")
})
TimeModeActivityNoTimePanel.resources = [
    "font/zzgftongxin_40_greenstroke.fnt",
    "cocos/one_step_get_count_panel.csb",
    "cocos/one_step_btn_help.csb",
    "cocos/one_step_btn_video.csb",
    "cocos/one_step.plist",
    "font/zzgftongxin_40_brownstroke.fnt"
]
TimeModeActivityNoTimePanel.load = function () {
    return new Promise((resolve, reject) => {
        preloadWithLoading(TimeModeActivityNoTimePanel.resources, resolve, reject, reject)
    })
}
TimeModeActivityNoTimePanel.prototype.ctor = function () {
    let self = this
    OneStepNoTimePanel.prototype.ctor.call(self)
    self.cat = "timeMode"
    self.subCat = "click_gethelp_btn"
}
TimeModeActivityNoTimePanel.prototype.getVideoKey = function () {
    return "timeMode_" +  + TimeModeActivityManager.getInstance().begin
}
TimeModeActivityNoTimePanel.prototype.getConfigNoShareDays = function () {
    return TimeModeActivityManager.getInstance().noShareDays
}
TimeModeActivityNoTimePanel.prototype.getConfigTodayVideoCount = function () {
    return TimeModeActivityManager.getInstance().todayVideoCount
}

TimeModeActivityNoTimePanel.prototype.initUI = function () {
    let self = this
    OneStepNoTimePanel.prototype.initUI.call(self, false)
    let tipLabel = self.getChildByName("tip")
    tipLabel.setString(getText("time.match.invite.text"))

    if (self.helpBtn && self.helpBtn.isVisible()) {
        DCAssist.dc4ShareShow("timeModeAskHelp");
    }
}

TimeModeActivityNoTimePanel.prototype.sendWatchVideoHttp = function () {
    let self = this
    return new Promise((resolve, reject) => {
        let http = TimeModeWatchVideoHttp.new()
        http.addEventListener(Events.kComplete, (evt) => {
            resolve()
        })
        http.addEventListener(Events.kError, () => {
            reject()
        })
        http.addEventListener(Events.kCancel, () => {
            reject()
        })
        http.load()
    })
}

TimeModeActivityNoTimePanel.prototype.onVideoHttpResponse = function () {
    let self = this
    let manager = TimeModeActivityManager.getInstance()
    manager.leftTimes++
        
    let getCountNoShare = Persistence.readFileData(LocalDataFiles.kGetCountNoShare) || {}
    let noShareInfo
    let key = self.getVideoKey()
    if (getCountNoShare[key]) {
        noShareInfo = getCountNoShare[key]
    } else {
        noShareInfo = {}
        getCountNoShare[key] = noShareInfo
    }
    noShareInfo.todayVideoCount = (noShareInfo.todayVideoCount || 0) + 1
    Persistence.writeFileData(getCountNoShare, LocalDataFiles.kGetCountNoShare)
    
    self.onClose(() => {
        self.dispatchEvent({
            name: PanelEvent.Close
        })
    })

}
TimeModeActivityNoTimePanel.prototype.onCleanup = function () {
    ResManager.release(TimeModeActivityNoTimePanel.resources)
}
module.exports = [TimeModeActivityNoTimePanel, PanelEvent]